// Shared display labels for background-agent job types (German UI). One source of
// truth so ActivityMenu / Sidebar / Workflow can't drift. Uploads are tracked in
// document_processing_status (not the jobs table), so there is no 'upload' entry.
export const AGENT_LABELS = {
  approval: "Zulassung",
  matching: "LV-Abgleich",
  compliance: "Extraktion",
  schema: "Schema-Analyse",
  takeoff: "Mengenermittlung",
  pipeline_structure: "Zulassung · Struktur",
  pipeline_run: "Zulassung · Extraktion",
};

export default AGENT_LABELS;
